export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "overpass.worker.aff6d8177b316d511bd7.worker.js");
}
